import PublicLayout from "@/components/layouts/bootstrap/PublicLayout";
import Link from "next/link";
import { useRouter } from "next/router";
import { Image } from 'react-bootstrap';

export default function Media()
{
    const router = useRouter();
    return (

        <>
            <section className="hero-reseller media-reseller d-flex align-items-center text-white ">
                <div className="container hero-inner p-3">
                    <div className="hero-copy d-inline-block">
                        <h1 className="publicBannerHeading">Media</h1>
                    </div>
                </div>
                <Link
                    className="btn btn-info text-white mt-3 float-end"
                    href="/industry_questions"
                >
                    VIEW EXPERT QUESTIONS
                </Link>
            </section>

            <section className="py-5 bg-white">
                <div className="container">
                    <div className="mb-4">
                        <button
                            onClick={() => router.back()}
                            className="button btn-purple me-3 text-uppercase border-0 p-2 px-3"
                        >
                            Back
                        </button>
                        <Link className="button btn-purple me-3" href="/contact">BOOK A DEMO</Link>
                        <Link className="button btn-purple me-3" href="/register">REGISTER</Link>
                        <Link className="button btn-purple me-3" href="/pricing">PRICING</Link>
                        <Link className="button btn-purple me-3" href="/register">TRY A FREE POLL</Link>

                        <Link className="button btn-purple" href="/faq">FAQ</Link>
                    </div>
                    <div className="row align-items-center">

                        <div className="col-lg-6 mb-4 mb-lg-0">
                            <h2 className="fw-bold secondaryColor mb-4 publicTextNew">
                                Captivate your audience. Shape the narrative.
                            </h2>
                            <p className="text-muted mb-3">
                                In the fast-paced world of media and broadcast, engagement is the currency of success.
                                Static content is no longer enough; audiences want to be part of the story as it unfolds.
                                Instant Polls gives <b>journalists, broadcasters, and content creators</b> the power to capture
                                <b> live audience sentiment</b>, validate trending topics, and turn viewers into active participants in real time.
                            </p>

                            <p className="text-muted mb-3">
                                Whether you are hosting a <b>live news segment</b>, a podcast, or a digital streaming event,
                                our platform turns passive consumption into an <b>interactive broadcast experience</b>.
                                By displaying results instantly, you spark deeper debate, increase viewer retention,
                                and ensure your content reflects what the world is thinking right now.
                            </p>

                            <p className="text-muted mb-3">
                                Because when <b>audience insight</b> moves at the speed of the broadcast, every story hits home.
                            </p>
                            {/* <p className="text-muted mb-3">
                                Keep your viewers, listeners, and readers engaged—and coming back for more—by turning every show, broadcast, or edition into an interactive poll that holds their attention until the results are unveiled on-air or revealed in tomorrow’s paper.</p> */}
                        </div>
                        <div className="col-lg-6 text-center">
                            <Image src="/industry/media-audience-polling.png" alt="media audience engagement polling solution" className="img-fluid newImageSizes" />
                        </div>
                    </div>
                </div>
            </section>

            <section className="py-5 bg-blue">
                <div className="container text-center">
                    <div className="row g-5">
                        <div className="col-md-6 col-lg-4">
                            <div className="card border-0 h-100 bg-unset">
                                <div className="card-body">
                                    <h5 className="card-title bu-semibold mb-3 text-start">The Challenge</h5>
                                    <p className="text-start">
                                        In a world of constant content, capturing and holding audience attention is harder than ever.
                                        Traditional media is often a one-way street, leaving viewers and listeners as passive observers.
                                        For <b>broadcasters</b> and <b>content creators</b>, the delay between a segment and audience feedback means missing the chance to pivot or dive deeper into what truly resonates.
                                        Without <b>real-time interaction</b>, you risk losing your audience to the next distraction.
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6 col-lg-4">
                            <div className="card border-0 h-100 bg-unset">
                                <div className="card-body">
                                    <h5 className="card-title bu-semibold mb-3 text-start">The Solution </h5>
                                    <p className="text-start">
                                        From national news networks to independent digital creators, Instant Polls helps turn <b>audience feedback</b> into immediate broadcast direction.
                                        It improves <b>viewer retention</b>, accelerates story development, and ensures that hosts remain deeply connected to the pulse of their audience.
                                        The result is a <b>media experience</b> that feels more dynamic, responsive, and influential — one that transforms a one-way broadcast into a two-way conversation.
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6 col-lg-4">
                            <div className="card border-0 h-100 bg-unset">
                                <div className="card-body">
                                    <h5 className="card-title bu-semibold mb-3 text-start">The Result</h5>
                                    <p className="text-start">
                                        From national news networks to independent digital creators,
                                        Instant Polls helps turn <b> audience feedback </b> into immediate broadcast direction.
                                        It improves <b> viewer retention </b>, accelerates story development, and ensures that hosts remain deeply
                                        connected to the pulse of their audience. The result is a <b> media experience </b> that feels more dynamic,
                                        responsive, and influential — one that transforms a one-way broadcast into a two-way conversation.

                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className="features py-5">
                <div className="container">
                    <h2 className="text-center fw-bold mb-4 highlightedColor">How Instant Polls Works</h2>
                    <div className="row g-4">
                        <div className="col-12 col-md-6 col-lg-3">
                            <div className="rfeature-card d-flex">
                                <div className="rfeature-icon">
                                    <Image src="/industry/icons/dashboard.png" alt="polls analytics dashboard icon" className="img-fluid" />
                                </div>
                                <div>
                                    <div className="rfeature-title">Integrate Audience Polling</div>
                                    <p className="rfeature-text">Add simple, on-screen or embedded polls to TV, radio, or digital campaigns.<br />
                                        Use custom branding for sponsors or advertisers.</p>
                                </div>
                            </div>
                        </div>

                        <div className="col-12 col-md-6 col-lg-3">
                            <div className="rfeature-card d-flex">
                                <div className="rfeature-icon">
                                    <Image src="/industry/icons/artificial-intelligence.png" alt="AI-powered polling intelligence icon" className="img-fluid" />
                                </div>
                                <div>
                                    <div className="rfeature-title">Engage &amp; Measure Live</div>
                                    <p className="rfeature-text">Capture viewer, listener, or reader sentiment during ads or content.<br />
                                        Poll audiences on brand recognition, product interest, or message recall.</p>
                                </div>
                            </div>
                        </div>

                        <div className="col-12 col-md-6 col-lg-3">
                            <div className="rfeature-card d-flex">
                                <div className="rfeature-icon">
                                    <Image src="/industry/icons/segmentation.png" alt="audience segmentation icon" className="img-fluid" />
                                </div>
                                <div>
                                    <div className="rfeature-title">Analyse in Real Time</div>
                                    <p className="rfeature-text">Get live dashboards showing engagement, reactions, and reach.<br />
                                        Segment by demographics, device, or channel.</p>
                                </div>
                            </div>
                        </div>

                        <div className="col-12 col-md-6 col-lg-3">
                            <div className="rfeature-card d-flex">
                                <div className="rfeature-icon">
                                    <Image src="/industry/icons/system.png" alt="system integration icon" className="img-fluid" />
                                </div>
                                <div>
                                    <div className="rfeature-title">Report &amp; Optimise</div>
                                    <p className="rfeature-text">Deliver post-campaign reports with verified engagement insights.<br />
                                        Use results to refine ad strategy and maximise sponsor ROI.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className="py-5 publicNewBgvColor">
                <div className="container testimonials">
                    <h2 className="mb-5 text-purple">Hear From Our Users</h2>
                    <div className="row g-4">
                        <div className="col-md-4">
                            <div className="bs-quotes">
                                <p>“Instant Polls changed how we run leadership meetings. We get clarity in minutes instead of waiting on surveys.”</p>
                                <cite>Managing Director, Professional Services</cite>
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="bs-quotes">
                                <p>“As an event organiser, I finally have live engagement metrics to show sponsors real ROI.”</p>
                                <cite>Event Manager</cite>
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="bs-quotes">
                                <p>“Our students love it. Real-time feedback makes learning more interactive.”</p>
                                <cite>University Lecturer</cite>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className="d-industry py-5 bg-white">
                <div className="container">
                    <h2 className="text-center fw-bold secondaryColor" >Key Benefits for Media Advertisers</h2>
                    <p className="text-center lead-mini mb-5">
                        From boardrooms to classrooms, <br className="d-none d-md-inline" />
                        Instant Polls adapts to your world.
                    </p>

                    <div className="row gy-4 gy-lg-5">
                        <div className="col-12 col-md-6 col-lg-3">
                            <div className="industry-items">
                                <div className="industry-icon"><Image src="/industry/images/briefcase.png" alt="business polling solutions icon" /></div>
                                <div>
                                    <div className="industry-title titleSameHeight">Measurable Engagement</div>
                                    <p className="industry-text">
                                        Move beyond impressions and ratings.
                                        Show advertisers live participation rates, sentiment, and recall — quantifiable proof of value.
                                    </p>
                                </div>
                            </div>
                        </div>

                        <div className="col-12 col-md-6 col-lg-3">
                            <div className="industry-items">
                                <div className="industry-icon"><Image src="/industry/images/education.png" alt="education polling solutions icon" /></div>
                                <div>
                                    <div className="industry-title titleSameHeight">Premium Sponsorship Opportunities</div>
                                    <p className="industry-text">
                                        Offer real-time polling integrations as premium ad packages — where brands can ask questions directly, gather insights, and display results instantly.            </p>
                                </div>
                            </div>
                        </div>

                        <div className="col-12 col-md-6 col-lg-3">
                            <div className="industry-items">
                                <div className="industry-icon"><Image src="/industry/images/event.png" alt="events polling solutions icon" /></div>
                                <div>
                                    <div className="industry-title titleSameHeight">Brand Interaction That Converts</div>
                                    <p className="industry-text">
                                        Give audiences something to do — not just something to see.
                                        Interactive ads generate higher retention and stronger emotional connection.
                                    </p>
                                </div>
                            </div>
                        </div>

                        <div className="col-12 col-md-6 col-lg-3">
                            <div className="industry-items">
                                <div className="industry-icon"><Image src="/industry/images/government.png" alt="government polling solutions icon" /></div>
                                <div>
                                    <div className="industry-title titleSameHeight">White-Label Branding</div>
                                    <p className="industry-text">
                                        Deliver the experience under your network’s or client’s brand.
                                        Keep your visual identity — Instant Polls works invisibly behind the scenes.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className="py-5 bg-blue">
                <div className="container text-center">
                    <div className="row g-5">
                        <div className="col-12">
                            <h2 className="text-center fw-bold secondaryColor">
                                Key Benefits for Media Advertisers
                            </h2>
                        </div>
                        {/* <h2 className="text-center fw-bold secondaryColor" >Key Benefits for Media Advertisers</h2> */}
                        <div className="col-md-6 col-lg-4">
                            <div className="card border-0 h-100 bg-unset">
                                <div className="card-body">
                                    <h5 className="card-title bu-semibold mb-3 text-start">Television &amp; Streaming</h5>
                                    <p className="card-text text-muted">
                                        Measure audience response to ad campaigns and sponsored segments.</p>
                                    <p className="card-text text-muted">Display instant polling results during commercial breaks or shows.</p>
                                    <p className="card-text text-muted">Deliver engagement analytics back to advertisers.</p>
                                </div>
                            </div>
                        </div>

                        <div className="col-md-6 col-lg-4">
                            <div className="card border-0 h-100 bg-unset">
                                <div className="card-body">
                                    <h5 className="card-title bu-semibold mb-3 text-start">Radio &amp; Podcasts</h5>
                                    <p className="card-text text-muted">Capture live listener participation on-air.</p>
                                    <p className="card-text text-muted">Integrate polling with talkback or live reads.</p>
                                    <p className="card-text text-muted">Report real-time listener sentiment to sponsors.</p>
                                </div>
                            </div>
                        </div>

                        <div className="col-md-6 col-lg-4">
                            <div className="card border-0 h-100 bg-unset">
                                <div className="card-body">
                                    <h5 className="card-title bu-semibold mb-3 text-start">Digital &amp; Print Media</h5>
                                    <p className="card-text text-muted">Embed sponsor-branded polls within articles or ad units.</p>
                                    <p className="card-text text-muted">Turn every click into actionable engagement data.</p>
                                    <p className="card-text text-muted">Offer clients a new measurable ad format.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className="py-5">
                <div className="container">
                    <div className="row align-items-center">
                        <div >
                            <h3 className="fw-bold mb-3 publicTextNew">Audience engagement at the speed of live</h3>
                            <p className="text-muted mb-3">From breaking news rooms to digital streaming studios, Instant Polls turns passive viewers into active contributors. By integrating <b> live audience sentiment </b> directly into your broadcast, you create a high-stakes,<b> interactive media experience</b> that keeps eyes on the screen and voices in the mix.</p>
                            <p className="text-muted mb-3">
                                The result is a more dynamic, responsive broadcast that doesn&#39;t just report the news—it drives it. Because when <b> audience insight </b> moves at the speed of the moment,
                                every segment delivers a higher impact, deeper retention, and a stronger connection to the pulse of the public.                                </p>

                        </div>
                    </div>
                </div>
            </section>

            <section className="lead-section-edu d-flex align-items-center">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-lg-6 py-5">
                            <h3 className="fw-bold mb-3 publicTextNew">Turn Every Ad Into a Live Conversation</h3>
                            <p className="text-muted mb-3">Instant Polls helps you deliver data your advertisers can see, trust, and pay more for.</p>
                            <Link href="/contact" className="btn btn-purple rounded-pill px-4 py-2 me-3">BOOK A DEMO</Link>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

Media.getLayout = (page) => <PublicLayout>{page}</PublicLayout>;